import { useBasicDataQuery } from "@services/basicData/basicData";
import { addQToItem } from "@utils/helpers";
import { useContracts } from "./useContracts";
import { useHouseExaminations } from "./useHouseExaminations";

export const useCachedBasicData = () => {
  const { data: basicDataResponse, ...restBasicDataQuery } =
    useBasicDataQuery({ enabled: true });
  const basicData = basicDataResponse?.data?.data || {};
  const {
    contracts,
    makkahContracts,
    madinahContracts,
    ...restContractsDataQuery
  } = useContracts();
  const { houseExaminations, ...restHouseExaminationsQuery } =
    useHouseExaminations();

  const cachedBasicDataEntries = Object.entries({
    ...basicData,
    ...houseExaminations,
  }).map(([key, arr]) => {
    // add q (query) property to the item (search by all values and arabic numerals)
    return [key, arr?.map?.(addQToItem)];
  });

  const cachedBasicData = Object.fromEntries(cachedBasicDataEntries);


  return {
    cachedBasicData: {
      ...cachedBasicData,
      contracts: contracts.map(addQToItem),
      makkahContracts: makkahContracts.map(addQToItem),
      madinahContracts: madinahContracts.map(addQToItem),
    },
    basicDataResponse: { ...basicDataResponse, ...restBasicDataQuery },
    contractsDataResponse: restContractsDataQuery,
    houseExaminationsDataResponse: restHouseExaminationsQuery,
  };
};
